module.exports = __webpack_public_path__ + "media/landing-page/dpd-bubble-64aa85f6.png";